import invoiceItem from "./invoiceItem.component";
import invoiceItemUrls from "./invoiceItem.urls";
import InvoiceItemTransforms from "./invoiceItem.transforms";

const invoiceItemModule = angular
  .module("app.components.invoiceItem", [])
  .component("invoiceItemPage", invoiceItem)
  .service("InvoiceItemTransforms", InvoiceItemTransforms)
  .config(invoiceItemUrls);

export default invoiceItemModule;



// WEBPACK FOOTER //
// ./src/pages/invoiceItem/invoiceItem.module.js